import { render, staticRenderFns } from "./DiagramNode.vue?vue&type=template&id=6da56cf5&"
import script from "./DiagramNode.vue?vue&type=script&lang=js&"
export * from "./DiagramNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da56cf5')) {
      api.createRecord('6da56cf5', component.options)
    } else {
      api.reload('6da56cf5', component.options)
    }
    module.hot.accept("./DiagramNode.vue?vue&type=template&id=6da56cf5&", function () {
      api.rerender('6da56cf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiagramNode.vue"
export default component.exports